export const TRAINABILITY_LEVELS = [
  "underload",
  "suboptimal",
  "optimal",
  "supraoptimal",
  "overload",
];

export const TRAINABILITY_LEVEL_META = {
  underload: {
    color: "#60A5FA",
    textColor: "#3B82F6",
    colorHex: 0x60a5fa,
    i18nKey: "trainability_levels.underload",
  },
  suboptimal: {
    color: "#CDDC39",
    textColor: "#9AAA12",
    colorHex: 0xcddc39,
    i18nKey: "trainability_levels.suboptimal",
  },
  optimal: {
    color: "#4ADE80",
    textColor: "#22C55E",
    colorHex: 0x4ade80,
    i18nKey: "trainability_levels.optimal",
  },
  supraoptimal: {
    color: "#2DD4BF",
    textColor: "#0D9488",
    colorHex: 0x2dd4bf,
    i18nKey: "trainability_levels.supraoptimal",
  },
  overload: {
    color: "#F87171",
    textColor: "#EF4444",
    colorHex: 0xf87171,
    i18nKey: "trainability_levels.overload",
  },
};

export const TRAINABILITY_NEUTRAL_COLOR = "#A8B2C1";
export const TRAINABILITY_NEUTRAL_HEX = 0xa8b2c1;

export const TRAINABILITY_MODE_KEYS = ["9030", "9060", "AL30", "AL60"];

export const normalizeTrainabilityLevel = (raw) => {
  if (typeof raw !== "string") return null;
  const level = raw.trim().toLowerCase();
  return TRAINABILITY_LEVEL_META[level] ? level : null;
};

export const getTrainabilityLevelColor = (level) =>
  TRAINABILITY_LEVEL_META[level]?.color ?? TRAINABILITY_NEUTRAL_COLOR;

export const getTrainabilityLevelTextColor = (level) =>
  TRAINABILITY_LEVEL_META[level]?.textColor
  ?? TRAINABILITY_LEVEL_META[level]?.color
  ?? TRAINABILITY_NEUTRAL_COLOR;

export const getTrainabilityLevelHex = (level) =>
  TRAINABILITY_LEVEL_META[level]?.colorHex ?? TRAINABILITY_NEUTRAL_HEX;

export const getTrainabilityLevelI18nKey = (level) =>
  TRAINABILITY_LEVEL_META[level]?.i18nKey ?? null;
